import { useState } from "react";
import { useParams } from "react-router";
import { GQLQuery, GQLQueryOrderInput } from "@rx-cs-system/schema";
import { useQuery } from "@apollo/client/react";

import { useCheckUserRole, useHandleError } from "../../../hooks";
import {
  DeliveryOrderProps,
  DeliveryOrderDetailPage as Component,
} from "../../../components/pages/deliveryOrder/DeliveryOrderDetailPage";
import { DeliveryOrderDetailProduct } from "../../../components/atoms/DeliveryOrderDetailProduct";
import { GET_DELIVERY_ORDER } from "../../../graphql/queries";
import { parseDeliveryOrderDetail } from "../../../graphql/utils";
import { sortDeliveryOrderDetail } from "../../../hooks/useSortDeliveryOrderDetail";

export const DeliveryOrderDetailPage = () => {
  useCheckUserRole();

  // @ts-ignore idが存在するのに「ない」と怒られるので
  const { id: deliveryOrderId } = useParams();

  const [sort, setSort] = useState<GQLQueryOrderInput>();

  const { error, data } = useQuery<GQLQuery>(GET_DELIVERY_ORDER, {
    variables: { id: deliveryOrderId },
  });
  useHandleError(error);

  if (!deliveryOrderId) throw new Error("deliveryOrderId is undefined");

  useHandleError(error);

  if (!data?.deliveryOrder) {
    return null;
  }

  // get and sort 物品 list
  const { deliveryOrderProducts } = sortDeliveryOrderDetail(
    parseDeliveryOrderDetail(data.deliveryOrder),
    sort,
  );

  const onSortDetailCkick = (input: GQLQueryOrderInput) => {
    setSort(input);
  };

  const productList = (
    <DeliveryOrderDetailProduct
      products={deliveryOrderProducts}
      order={sort}
      onSortDetailClick={onSortDetailCkick}
    />
  );

  const props: DeliveryOrderProps = {
    deliveryOrder: parseDeliveryOrderDetail(data.deliveryOrder),
    products: productList,
  };

  return <Component {...props} />;
};
